export enum ProcessingStatus {
  ACTIVE = 'active',
  ARCHIVING = 'archiving',
  ARCHIVED = 'archived',
  RESTORING = 'restoring',
  RESTORED = 'restored',
}
